import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import {BeatLoader} from "react-spinners";
import { override } from '../helpers/utils.js';
import jwt_decode from "jwt-decode";
class RefundBankRRN extends Component{
    constructor(props) {
        super(props);
        this.state ={
            RefundBankRRNID:'',
            RefundBankRRNList:[{value: '', label: 'Select'}],
            is_RefundBankRRN_loading: true,
            RefundBankRRNValue: [],
            RefundBankRRNListOpen: false,
            RefundBankRRNHeaderTitle: "Select [RefundBankRRN]",
            object_code:[],
            RefundBankRRNObject:[],
            search_object_code:[],
            RefundBankRRN_name:""

        }
        this.closeRefundBankRRNList = this.closeRefundBankRRNList.bind(this);
    }

    componentDidUpdate() {
        const { RefundBankRRNListOpen } = this.state;
        setTimeout(() => {
            if (RefundBankRRNListOpen) {
                window.addEventListener('click', this.closeRefundBankRRNList);
            } else {
                window.removeEventListener('click', this.closeRefundBankRRNList);
            }
        }, 0);
    }

    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        this.setState({
            userGroupName:decoded.userGroupName,
            object_code:decoded.object_code,
            object_type:decoded.object_type
        })
        this.getRefundBankRRN(decoded.object_type,arrayCode,false,'',this.props.start_date,this.props.end_date);
    }
    restRefundBankRRNFilter(){
        this.setState({
            RefundBankRRNID: [],
        })
    }
    getRefundBankRRN(object_type, object_code,is_search, search_value,start_date, end_date) {
        //alert(code); alert(type)
        if(is_search===false){
            this.setState({
                RefundBankRRNID:[]
            })
        }
        this.setState({
//             search_code: code,
//             search_type: type,
            object_type: object_type,
            search_object_code: object_code
        })
        let selected_val = [];
        if(is_search===true){
            selected_val = this.state.RefundBankRRNObject
        }
        this.setState({
            RefundBankRRNList:[],
            is_RefundBankRRN_loading: true
        })
        var url = '/filters/get-refund-filters';

        axios.post(config.get('API_URL')+url, {
                user_type: object_type,
                object_code: object_code,
                filter_type: "Refund_Bank_RRN",
                is_search: is_search,
                search_value: search_value,
                selected_value: selected_val,
                start_date: start_date,
                end_date: end_date
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then((response) => {
                let RefundBankRRNList = [];
                //this.setState({RefundBankRRNID:''});
                console.log('Response**',response)
                response.data.map((RefundBankRRN,index) => {
                    RefundBankRRNList.push({value: RefundBankRRN.Refund_Bank_RRN, label: RefundBankRRN.Refund_Bank_RRN})
                });
                let res = []
                if (Array.isArray(this.state.RefundBankRRNID) && this.state.RefundBankRRNID) {
                    const uniq = new Set(RefundBankRRNList.map(e => JSON.stringify(e)));

                    RefundBankRRNList = Array.from(uniq).map(e => JSON.parse(e));

                }
                this.setState({
                    RefundBankRRNList:RefundBankRRNList,
                    is_RefundBankRRN_loading: false
                })
            }).catch((e)=>{
                console.log(e)
                this.setState({
                    is_RefundBankRRN_loading: false
                })
            })
    }
    changeRefundBankRRN(login_type, RefundBankRRN_object, checked_item, e) {
        if (login_type === 'RefundBankRRN') {
            let value='';
            let sidArray = [];
            if(RefundBankRRN_object.length<1){
                value = null;
                sidArray = '';
            }
            else{
                RefundBankRRN_object.map((sids, i) => {
                    sidArray.push(sids.value)
                });
            }
            this.setState({
                RefundBankRRNID: sidArray,
                RefundBankRRNValue:RefundBankRRN_object,
                ciutidIds: '',
                ciutidValue: [],
                isChange: true
            });
        } else {
            let item_list = this.state.RefundBankRRNID;
            let item_list_object = this.state.RefundBankRRNObject;
            let checked_list = RefundBankRRN_object.value;
            let checked_list_object = RefundBankRRN_object;
            //console.log(checked_list);
            if(checked_item===false) {
                const newData = [RefundBankRRN_object, ...this.state.RefundBankRRNList.filter(item => item !== RefundBankRRN_object)];
                this.setState({
                    RefundBankRRNID: [...this.state.RefundBankRRNID,RefundBankRRN_object.value],
                    RefundBankRRNObject: [...this.state.RefundBankRRNObject,RefundBankRRN_object],
                    isChange: true,
                    RefundBankRRNList: newData,
                    RefundBankRRN_name: RefundBankRRN_object.label,

                });

            } else{
                let index = item_list.indexOf(checked_list);
                if (index > -1) {
                    item_list.splice(index, 1);
                    if(item_list.length<1) {
                        item_list='';
                    }
                    this.setState({
                        RefundBankRRNID: item_list,

                    })
                }
                let index_object = item_list_object.indexOf(checked_list_object);
                if (index_object > -1) {
                    item_list_object.splice(index_object, 1);
                    if(item_list_object.length<1) {
                        item_list_object=[];
                    }
                    this.setState({
                        RefundBankRRNObject: item_list_object,
                        isChange: true
                    })
                }
            }
            setTimeout(function() {
                this.props.onSelectRefundBankRRN(this.state.RefundBankRRNID);
            }.bind(this), 200);
            if (e.target.type === 'checkbox') {
                e.stopPropagation();
            }
        }

    }
    removeRefundBankRRN(){
        const val = ''
        this.props.onSelectRefundBankRRN(val);
        this.setState({
            RefundBankRRNValue:[],
            RefundBankRRNID:'',
            RefundBankRRN_name:''
        });
    }
    RefundBankRRNToggleList() {
        this.setState({
            RefundBankRRNListOpen: !this.state.RefundBankRRNListOpen,
        });
    }
    RefundBankRRNFilterList(e){
        var value = e.target.value

        setTimeout(function() {
            this.getRefundBankRRN(this.state.object_type, this.state.search_object_code,true, value,this.props.start_date,this.props.end_date);
        }.bind(this), 200);
    }
    closeRefundBankRRNList() {
        this.setState({
            RefundBankRRNListOpen: false,
        });
    }

    render() {
        //console.log(this.state.RefundBankRRN_name);
        const RefundBankRRN_lists = this.state.RefundBankRRNList.map((RefundBankRRN_object, index) => {
            // console.log("RefundBankRRN_object");
            // console.log(RefundBankRRN_object);
            var chks_input = <input type='checkbox' checked={false}/>
            var activeCls_s = 'dd-list-item';
            var checked_items = false;
            if(this.state.RefundBankRRNID.includes(RefundBankRRN_object.value) === true){
                chks_input = <input type='checkbox' checked={true}/>
                activeCls_s = "dd-list-item dd-list-active";
                checked_items = true;
            }
            return (
                <li key={index} className={activeCls_s} onClick={this.changeRefundBankRRN.bind(this, '', RefundBankRRN_object,checked_items)}>
                    {chks_input}
                    &nbsp;&nbsp;{RefundBankRRN_object.label}
                </li>
            )
        })

        return(

            <div className="dd-wrapper">
                <div className="dd-header" onClick={() => this.RefundBankRRNToggleList()}>
                    {this.state.RefundBankRRNID==''?
                        <div className="dd-header-title">{this.state.RefundBankRRNHeaderTitle}</div>:
                        <div className="dd-header-title">{this.state.RefundBankRRNID.length} Selected</div>
                    }


{/*                     {this.state.RefundBankRRNListOpen===false? */}
                        <i className="fa fa-angle-down"></i>
{/*                     } */}
                </div>

                {this.state.RefundBankRRNListOpen ===true?
                    <div
                        role="list"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <input
                            className="dd-list-search-bar"
                            placeholder="Search"
                            onChange={(e) => this.RefundBankRRNFilterList(e)}
                        />
                        <i className="fa fa-search" style={{position:"absolute", left:"195px",color: "rgb(204, 204, 204)", marginTop:"5px", zIndex:2}}></i>

                        {/*<div className="dd-scroll-list">*/}
                        <ul className="dd-list">
                            {this.state.is_RefundBankRRN_loading===true?
                                <li>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={5}
                                        color={'#666666'}
                                        loading={this.state.is_RefundBankRRN_loading}
                                    />
                                </li>: null}
                            {RefundBankRRN_lists}

                        </ul> </div>: null }
                {/*</div>*/}
            </div>

        );
    }
}

export default RefundBankRRN;